import Component from './Grid';

export default Component;